import { Enumify } from "enumify-ts";
class SettlementPeriodType extends Enumify() {
    description;
    static WEEKLY = new SettlementPeriodType("Weekly (7 Days)");
    static FORTNIGHTLY = new SettlementPeriodType("Fortnightly (14 Days)");
    static TRI_WEEKLY = new SettlementPeriodType("Tri Weekly (21 Days)");
    static FOUR_WEEKLY = new SettlementPeriodType("Four Weekly (28 Days)");
    static _ = SettlementPeriodType._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
    static selectOptionsArray() {
        return SettlementPeriodType.values.map(it => {
            return {
                label: it.description,
                value: it.key
            };
        });
    }
}
export default SettlementPeriodType;
